/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentSystemLists.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for System List API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 8:25 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const SystemListGroups = {
    all: (companyid) => requests.get(`/SystemListGroups?companyid=${companyid ? companyid : 0}`),
    get: systemlistgroupid => requests.get(`/SystemListGroup/${systemlistgroupid}`),
    create: systemlistgroup => requests.post(`/SystemListGroups`, systemlistgroup),
    update: (systemlistgroupid, systemlistgroup) => requests.put(`/SystemListGroup/${systemlistgroupid}`, systemlistgroup),
    delete: systemlistgroupid => requests.del(`/SystemListGroup/${systemlistgroupid}`),
};

export const SystemLists = {
    all: (companyid, listgroupid) => requests.get(`/SystemLists?companyid=${companyid ? companyid : 0}&listgroupid=${listgroupid ? listgroupid : 0}`),
    getListSelect: () => requests.get(`/SystemListSelect`),
    get: systemlistid => requests.get(`/SystemList/${systemlistid}`),
    create: systemlist => requests.post(`/SystemLists`, systemlist),
    update: (systemlistid, systemlist) => requests.put(`/SystemList/${systemlistid}`, systemlist),
    delete: systemlistid => requests.del(`/SystemList/${systemlistid}`),
};

export const SystemListItems = {
    all: (listid, parentid) => requests.get(`/SystemListItems?listid=${listid ? listid : 0}&parentid=${parentid ? parentid : 0}`),
    get: systemlistitemid => requests.get(`/SystemListItem/${systemlistitemid}`),
    create: systemlistitem => requests.post(`/SystemListItems`, systemlistitem),
    update: (systemlistitemid, systemlistitem) => requests.put(`/SystemListItem/${systemlistitemid}`, systemlistitem),
    delete: (systemlistitemid, listid, parentid) => requests.del(`/SystemListItem/${systemlistitemid}?listid=${listid ? listid : 0}&parentid=${parentid ? parentid : 0}`),
};

export const SystemListItemPath = {
    get: parentid => requests.get(`/SystemListItemPath/${parentid}`)
};

export const SystemListItemTree = {
    get: (listid, parentid) => requests.get(`/SystemListItemTree?listid=${listid}&parentid=${parentid}`)
};